var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffeeMugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2004 81.1501C54.4158 81.1501 66.7504 77.4654 66.7504 72.9201C66.7504 68.3748 54.4158 64.6901 39.2004 64.6901C23.9849 64.6901 11.6504 68.3748 11.6504 72.9201C11.6504 77.4654 23.9849 81.1501 39.2004 81.1501Z",
    fill: "#96CBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1999 77.8401C28.3499 77.8401 16.6699 75.4901 16.6699 70.3101V30.3101C16.6699 25.1401 28.3499 22.7801 39.1999 22.7801C50.0499 22.7801 61.7299 25.1301 61.7299 30.3101V70.3101C61.7299 75.4801 50.0499 77.8401 39.1999 77.8401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2004 24.3101C50.8004 24.3101 60.2004 27.0001 60.2004 30.3101V70.3101C60.2004 73.6201 50.8004 76.3101 39.2004 76.3101C27.6004 76.3101 18.2004 73.6201 18.2004 70.3101V30.3101C18.2004 27.0001 27.6004 24.3101 39.2004 24.3101ZM39.2004 21.2601C36.7404 21.2601 15.1504 21.5101 15.1504 30.3101V70.3101C15.1504 79.1101 36.7404 79.3601 39.2004 79.3601C41.6604 79.3601 63.2504 79.1101 63.2504 70.3101V30.3101C63.2504 21.5201 41.6604 21.2601 39.2004 21.2601Z",
    fill: "#033967"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1996 32.7801C49.0579 32.7801 57.0496 31.3832 57.0496 29.6601C57.0496 27.937 49.0579 26.5401 39.1996 26.5401C29.3413 26.5401 21.3496 27.937 21.3496 29.6601C21.3496 31.3832 29.3413 32.7801 39.1996 32.7801Z",
    fill: "#033967"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7095 43.6601L46.8295 41.7901L39.1995 49.4201L31.5695 41.7901L29.6895 43.6601L37.8795 51.8401V64.5401H40.5295V51.8401L48.7095 43.6601Z",
    fill: "#96CBFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.47 35.8601H12.97C6.91 35.8601 2 40.7701 2 46.8301V49.6101C2 55.7801 7.00001 60.7801 13.17 60.7801H16.46V54.9101H14.13C10.5 54.9101 7.56001 51.9701 7.56001 48.3401C7.56001 44.7101 10.5 41.7701 14.13 41.7701H16.46V35.8601H16.47Z",
    fill: "#96CBFA",
    stroke: "#033967",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4492 17.9801C29.4492 15.8201 30.9492 15.8201 30.9492 13.6601C30.9492 11.5001 29.4492 11.5001 29.4492 9.33012C29.4492 7.17012 30.9492 7.17012 30.9492 5.00012",
    stroke: "#033967",
    strokeWidth: 2.8655,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4492 14.9801C38.4492 12.8201 39.9492 12.8201 39.9492 10.6601C39.9492 8.50013 38.4492 8.50012 38.4492 6.33012C38.4492 4.17012 39.9492 4.17012 39.9492 2.00012",
    stroke: "#033967",
    strokeWidth: 2.8655,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4102 17.9801C47.4102 15.8201 48.9102 15.8201 48.9102 13.6601C48.9102 11.5001 47.4102 11.5001 47.4102 9.33012C47.4102 7.17012 48.9102 7.17012 48.9102 5.00012",
    stroke: "#033967",
    strokeWidth: 2.8655,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMugIcon);
export default __webpack_public_path__ + "static/media/coffee-mug-icon.80659353e48a66196b9bcfd93ce30bfe.svg";
export { ForwardRef as ReactComponent };